import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
// import moment from "moment-business-days";

class ManagerBase extends Controller {
	constructor (name) {
		super(name);
		this.remoteClassName = "";
		this.localClassReference = null;
	}
	
	async getByGuid (guid, item = null) {
		const rd = NousCore.api.createRequest({ item: { guid } });
		const requestedAction = "get-by-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							if (item) {
								item.import(data.items[0]);
								item.clean();
							}
							else {
								item = new this.localClassReference(data.items[0]);
							}
	
							return {
								data: item,
								requestedAction,
								status: "ok",
							};
						}
						else {
							return {
								data: null,
								requestedAction,
								status: "ko",
							};
						}
					case 99:
						return {
							data: null,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async getFilteredList (destinationListName, retrunedInstanceClass, {incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-list";

		if (range) {
			rd.range = range;
		}

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						let retrievedList = Shark.getInstanceList(retrunedInstanceClass, data.items);
						
						if (incrementalRequest) {
							let destinationList = Shark.get(destinationListName);
							retrievedList = [...destinationList, ...retrievedList];
						}

						retrievedList.forEach((item, index) => item.__displayIndex = index + 1);

						Shark.set({
							[destinationListName]: retrievedList,
							[`__${destinationListName}NeedFurtherLoad`]: data.availableItemCount > retrievedList.length,
							__availableFurtherItems: data.availableItemCount - retrievedList.length,
						});

						return {
							data: retrievedList,
							requestedAction,
							status: "ok"
						};
					}
					case 404:
						return {
							data: null,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	getList () {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							status: "ok"
						};
					case 404:
						return {
							data,
							status: "ko"
						};
				}
			}
		});
	}

	getListByGuidList (guidList, filters) {
		const rd = NousCore.api.createRequest({ filters, item: {guidList} });
		const requestedAction = "get-list-by-guid-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data: null,
							error: data.error,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	getListByContactGuid (guid) {
		const rd = NousCore.api.createRequest({ item: {guid} });
		const requestedAction = "get-list-by-contact-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							status: "ok",
						};
					case 404:
						return {
							data,
							status: "ko",
						};
				}
			}
		});
	}

	save (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = item.guid === "" ? "insert" : "update";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						item.import(data.items[0]);
						item.clean();
						return {
							data: item,
							requestedAction,
							status: "ok",
						};
					case 9:
					case 99:
						return {
							data,
							errors: data.errors,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}
	
export default ManagerBase;
